import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import '@/styles/tokens.css';
import '@/styles/global.css';
import '@/themes/blobs/blobs.css';
import '@/themes/glass/glass.css';
import '@/themes/glass/liquid.css';
import { initSkin } from '@/lib/skin';
import '@/lib/i18n';
import { App } from '@/app/App';

// Service worker: offline shell, cached plates and sounds, web push (public/sw-push.js).
// A Home Screen app is mostly resumed from the background, not reloaded, so it also looks for a new version
// each time it comes back to the front and every 30 minutes; a new version then installs and reloads the app.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  registerSW({
    immediate: true,
    onRegisteredSW(_url, reg) {
      if (!reg) return;
      const check = () => { if (navigator.onLine) void reg.update().catch(() => undefined); };
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check(); });
      setInterval(check, 30 * 60 * 1000);
    },
  });
}

initSkin();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
